<header class="header">
  <h1 class="logo">
    <a routerLink="/" title="Logo"><img src="/assets/images/logo.png" alt="Logo" /></a>
  </h1>

  <mat-toolbar class="header-toolbar">
    <!-- Desktop menu -->
    <nav class="desktop-menu hidden lg:show">
      <li><a href="https://merckhelps.com/faq.aspx" target="_blank" class="menu-link">FAQ</a></li>
      <li><a href="https://www.merck.com/terms-of-use/" target="_blank" class="menu-link">Terms of Use</a></li>
      <li><a href="https://www.msdprivacy.com/us/en/" target="_blank" class="menu-link">Privacy</a></li>
      <li> <a href="#" class="menu-link" (click)="openModal($event)">Contact Us</a></li>
    </nav>
    <!-- Profile Menu -->
    <div class="profile">
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onLogout()">Logout</button>
      </mat-menu>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon svgIcon="profile"></mat-icon>
      </button>
    </div>

    <!-- Tablet hamburger menu button -->
    <button mat-icon-button (click)="toggleTabletMenu()" class="hamburger-menu">

      <mat-icon class="menu-icon">

        {{ isTabletMenuOpen ? 'close' : 'menu' }}
      </mat-icon>
    </button>
    <!-- Extra Hamburger Menu Button for Small Screens -->
    <button mat-icon-button (click)="onMenuOpen.emit()" class="hamburger-menu show md:hidden">
      <mat-icon class="menu-icon">menu</mat-icon>
    </button>

  </mat-toolbar>

  <!-- Tablet menu -->
  <div class="tablet-menu-overlay" *ngIf="isTabletMenuOpen" (click)="toggleTabletMenu()"></div>

  <nav class="tablet-menu" *ngIf="isTabletMenuOpen">
    <div class="menu-container">
      <div class="header">
        <a routerLink="/" title="Logo">
          <img src="/assets/images/logo.png" alt="Logo" class="logo" />
        </a>
        <button mat-icon-button (click)="toggleTabletMenu()" class="close-button">
          <mat-icon class="menu-icon">close</mat-icon>
        </button>
      </div>
      <div class="sidebar-container">
        <ul class="sidebar-footer">
          <li><a href="https://merckhelps.com/faq.aspx" target="_blank" class="menu-link">FAQ</a></li>
          <li><a href="https://www.merck.com/terms-of-use/" target="_blank" class="menu-link">Terms of Use</a></li>
          <li><a href="https://www.msdprivacy.com/us/en/" target="_blank" class="menu-link">Privacy</a></li>
          <li> <a href="#" class="menu-link" (click)="openModal($event)">Contact Us</a></li>

        </ul>
      </div>

    </div>
  </nav>
</header>